module.exports = "module.exports = {\n\t\"bindings\": [\n\t\t{\n\t\t\t\"type\": \"eventHubTrigger\",\n\t\t\t\"name\": \"myEventHubMessage\",\n\t\t\t\"direction\": \"in\",\n\t\t\t\"path\": \"%eventHubConnectionPath%\",\n\t\t\t\"connection\": \"eventHubConnectionString\",\n\t\t\t\"cardinality\": \"one\"\n\t\t}\n\t],\n\t\"disabled\": false\n};"


//////////////////
// WEBPACK FOOTER
// ./src/data/ShakeShake/azureFunction/function.json
// module id = 397
// module chunks = 0